// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AzIX","toggle":"styles_toggle__3XOaX","preview":"styles_preview__nZv5W"};